export const CO_GET_INCOTERMCITY_LISTING = "CO_GET_INCOTERMCITY_LISTING"
export const CO_GET_INCOTERMCITY_LISTING_SUCCESS = "CO_GET_INCOTERMCITY_LISTING_SUCCESS"
export const CO_GET_INCOTERMCITY_LISTING_FAILED = "CO_GET_INCOTERMCITY_LISTING_FAILED"